
























































import ToggleThreeState from '@/components/ToggleThreeState.vue'

export default
    props:
        # Either 'items', 'languages' or 'countries', matching the store
        filter_group:
            type: String
            required: true

    components: { ToggleThreeState }

    data: ->
        sortnames: ['Name', 'Total', 'Visible', 'Filter']
        sort: 'Name'
        dir: 'up'

    computed:
        items_unsorted: ->
            items = Object.values(@$store.state.filter[@filter_group])
            # remove items with a blank name (exists, but can't filter by it)
            items = items.filter( (x) => x.name )
            return items

        items: ->
            items = @items_unsorted

            if @sort == 'Name'
                items = items.sort (x, y) =>
                    return -1 if x.name < y.name
                    return 1 if x.name > y.name
                    return 0

            if @sort == 'Total'
                items = items.sort (x, y) =>
                    return -1 if x.total < y.total
                    return 1 if x.total > y.total
                    return 0

            if @sort == 'Visible'
                items = items.sort (x, y) =>
                    return -1 if x.visible < y.visible
                    return 1 if x.visible > y.visible
                    return 0

            if @sort == 'Filter'
                items = items.sort (x, y) =>
                    return -1 if x.filter < y.filter
                    return 1 if x.filter > y.filter
                    return 0

            if @dir == 'down'
                items.reverse()

            return items

    methods:
        setFilter: (id, state) ->
            @$store.commit 'filter/SET_FILTER',
                item_list_name: @filter_group
                item_id: id
                filter_state: state
        toggleSort: (sortname) ->
            if @sort == sortname
                @dir = if @dir == 'up' then 'down' else 'up'
            else
                @sort = sortname
        reset: ->
            @$store.commit 'filter/RESET_FILTER', @filter_group

